// extracted by mini-css-extract-plugin
export default {"switch":"notifications_switch__vTa0s","button":"notifications_button__Jjq1G","isOn":"notifications_isOn__NjKDL"};